/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Player_Already_FinishedInputs */



/**
* | output |
* | --- |
* | "Player already finished" |
*
* @param {Err_Tournament_Player_Already_FinishedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_player_already_finished = /** @type {((inputs?: Err_Tournament_Player_Already_FinishedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Player_Already_FinishedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le joueur a déjà terminé")
	if (locale === "es") return /** @type {LocalizedString} */ ("El jugador ya ha finalizado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O jogador já finalizou")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il giocatore ha già terminato")
	return /** @type {LocalizedString} */ ("Player already finished")
});